import React from 'react';
import './Monthly_matching_page.css';
import { Helmet } from 'react-helmet';
import GGApi from '../../../utils/GGApi';
import GG_loader from '../../general_components/GG_loader/GG_loader';
import Payment_methods from '../../Payment_methods/Payment_methods';
import Monthly_matching_summary from './Monthly_matching_summary';
import Header_for_multistep from '../../layout_components/Header_for_multistep/Header_for_multistep';
import gg_fees from '../../../utils/gg_pricing';
import GG_confetti from '../../general_components/GG_confetti/GG_confetti';
import { logEvent } from '../../../utils/analytics';

/** Decode JWT payload */
function getUserIdFromToken(accessToken) {
  if (!accessToken || typeof accessToken !== 'string') return null;
  try {
    const parts = accessToken.split('.');
    if (parts.length !== 3) return null;
    const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const decoded = JSON.parse(atob(payload));
    return decoded.user_id != null ? Number(decoded.user_id) : null;
  } catch (e) {
    return null;
  }
}

class Monthly_matching_page extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      invalid: false,
      error: null,
      paying: false,
      paid: false,

      details: null,
      guest: true,
      
      payment_methods: [],
      selected_payment_method: null,
      open_payments: false,
      
    };
    this.getToken = this.getToken.bind(this);
    this.handleDDSelection = this.handleDDSelection.bind(this);
    this.goToPayments = this.goToPayments.bind(this);
    this.handlePay = this.handlePay.bind(this);
    this.updateCard = this.updateCard.bind(this);
    this.bankNext = this.bankNext.bind(this);
    this.saveGiftForOauth = this.saveGiftForOauth.bind(this);
    this.resumeFcOauthIfNeeded = this.resumeFcOauthIfNeeded.bind(this);
    this.monthlyMatchingCompleteLogged = false;
  }

  resumeFcOauthIfNeeded() {
    if (this.props.fc_client_secret && this.props.fc_return_session) {
      this.setState({ open_payments: true });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.fc_client_secret && this.props.fc_client_secret) {
      this.resumeFcOauthIfNeeded();
    }
    if (!prevState.paid && this.state.paid && this.state.details && !this.monthlyMatchingCompleteLogged) {
      this.monthlyMatchingCompleteLogged = true;
      const details = this.state.details;
      logEvent('matching: complete monthly matching', {
        source: 'monthly_matching',
        amount_cents: Number(details.total_matched_cents) || 0,
        convenience_fee_cents: Number(details.convenience_fee_cents) || 0,
        invoice_status: details.status || null,
      });
    }
  }

  saveGiftForOauth() {
    localStorage.setItem('gift', JSON.stringify({ monthly_matching: true }));
  }

  getToken() {
    const search = this.props.location && this.props.location.search ? this.props.location.search : '';
    const params = new URLSearchParams(search);
    return params.get('t') || '';
  }

  componentDidMount() {
    const token = this.getToken();
    if (!token) {
      this.setState({ loading: false, invalid: true });
      return;
    }
    GGApi.get_monthly_matching_details(token)
      .then((data) => {
        if (data.message && data.message !== 'Invoice not found.') {
          this.setState({ loading: false, invalid: true, error: data.message });
          return;
        }
        const matcherUserId = data.matcher_user_id != null ? Number(data.matcher_user_id) : null;
        const user = JSON.parse(localStorage.getItem('user'));
        const currentUserId = user && user.accessToken ? getUserIdFromToken(user.accessToken) : null;

        const isMismatch = user && (matcherUserId == null || currentUserId !== matcherUserId);
        if (isMismatch) {
          localStorage.removeItem('user');
          localStorage.removeItem('entitlements');
          alert("You've been signed out.");
        }

        if (data.status === 'paid') {
          logEvent('matching: view monthly matching', {
            source: 'monthly_matching',
            token_valid: true,
            invoice_status: 'paid',
          });
          this.setState({ loading: false, details: data, paid: true, guest: true });
          return;
        }
        const isMatcherSession = user && !isMismatch && matcherUserId != null && currentUserId === matcherUserId;
        logEvent('matching: view monthly matching', {
          source: 'monthly_matching',
          token_valid: true,
          invoice_status: data.status || null,
          guest: !isMatcherSession,
        });
        this.setState({ loading: false, details: data, guest: !isMatcherSession });
        if (isMatcherSession) {
          GGApi.checkToken().then((tokenValid) => {
            if (tokenValid) {
              this.setState({ guest: false });
              GGApi.pm_get().then((list) => {
                if (list && list.length > 0) {
                  const first = list[0].items && list[0].items[0];
                  if (first) this.setState({ selected_payment_method: first });
                  this.setState({ payment_methods: list });
                }
              });
            } else {
              this.setState({ guest: true });
            }
          }).catch(() => {
            this.setState({ guest: true });
          });
        }
        this.resumeFcOauthIfNeeded();
      })
      .catch(() => this.setState({ loading: false, invalid: true, error: 'Something went wrong.' }));
  }

  handleDDSelection(item, dd_name) {
    if (dd_name === 'payment_method') {
      this.setState({ selected_payment_method: item });
    }
  }

  goToPayments() {
    this.setState({ open_payments: true });
  }

  calculateFees() {
    const d = this.state.details;
    const pm = this.state.selected_payment_method;
    if (!d || !pm) return 0;
    const totalCents = Number(d.total_matched_cents) || 0;
    let fee = 0;
    if (pm.type === 'CC') {
      fee = Math.floor(totalCents * gg_fees.send_fees.cc_variable + gg_fees.send_fees.cc_fixed);
    } else if (pm.type === 'ACH') {
      fee = Math.floor(totalCents * gg_fees.send_fees.ach_variable + gg_fees.send_fees.ach_fixed);
    }
    return fee;
  }

  calculateTotalDue() {
    const d = this.state.details;
    if (!d) return 0;
    const totalCents = Number(d.total_matched_cents) || 0;
    const feeCents = this.calculateFees();
    return totalCents + feeCents;
  }

  updateCard(payment_method, save_method) {
    let pm_logo = 'https://gg-app-images.s3.us-east-2.amazonaws.com/linked_account_logos/logo_CC_generic_card.png';
    switch (payment_method.card.brand) {
      case 'visa': pm_logo = 'https://gg-app-images.s3.us-east-2.amazonaws.com/linked_account_logos/logo_CC_visa.png'; break;
      case 'amex': pm_logo = 'https://gg-app-images.s3.us-east-2.amazonaws.com/linked_account_logos/logo_CC_AmEx.png'; break;
      case 'diners': pm_logo = 'https://gg-app-images.s3.us-east-2.amazonaws.com/linked_account_logos/logo_CC_diners.png'; break;
      case 'discover': pm_logo = 'https://gg-app-images.s3.us-east-2.amazonaws.com/linked_account_logos/logo_CC_discover.png'; break;
      case 'mastercard': pm_logo = 'https://gg-app-images.s3.us-east-2.amazonaws.com/linked_account_logos/logo_CC_mastercard.png'; break;
      default: break;
    }
    const new_pm = {
      id: payment_method.id,
      type: 'CC',
      main_text: payment_method.card.brand,
      sub_text: '•••• ' + payment_method.card.last4,
      image: pm_logo,
      save_this_method: save_method,
      pm_name: payment_method.card.brand,
      pm_last4: payment_method.card.last4,
    };
    const list = this.state.payment_methods;
    let cat = list.find((c) => c.category_header === 'Credit Cards');
    if (!cat) {
      cat = { id: 2, category_header: 'Credit Cards', category_subtext: '3.5% Payment Processing Fee', items: [], color: 'gg_red' };
      list.push(cat);
    }
    cat.items.push(new_pm);
    this.setState({
      selected_payment_method: new_pm,
      payment_methods: [...list],
      open_payments: false,
    });
  }

  bankNext(new_bank) {
    const achVerified = new_bank.verified === 1 || new_bank.verified === true;
    const new_pm = {
      id: new_bank.method_api_id,
      type: 'ACH',
      verified: achVerified,
      main_text: new_bank.method_name,
      sub_text: '•••• ' + new_bank.method_last4,
      image: new_bank.method_logo,
    };
    const list = this.state.payment_methods;
    const pendingHeader = 'Bank Debits - ACH (pending verification)';
    const verifiedHeader = 'Bank Debits - ACH';
    const categoryHeader = achVerified ? verifiedHeader : pendingHeader;
    let cat = list.find((c) => c.category_header === categoryHeader);
    if (!cat) {
      cat = {
        id: achVerified ? 1 : 3,
        category_header: categoryHeader,
        category_subtext: achVerified ? '1% Payment Processing Fee' : 'Verification Required',
        items: [],
        disabled: !achVerified,
      };
      list.push(cat);
    }
    cat.items.push(new_pm);
    const nextState = {
      payment_methods: [...list],
      open_payments: false,
    };
    if (achVerified) {
      nextState.selected_payment_method = new_pm;
    }
    this.setState(nextState);
  }

  handlePay() {
    // Step 1: validate required values: token, selected payment method, stripe instance
    const token = this.getToken();
    const pm = this.state.selected_payment_method;
    const { stripe } = this.props;
    if (!token || !pm) {
      if (!pm) alert('Please select a payment method');
      return;
    }

    // Step 2: if logged in, verify session is still valid before proceeding
    if (!this.state.guest) {
      GGApi.checkToken()
        .then((tokenValid) => {
          if (!tokenValid) {
            alert("You've been logged out due to inactivity. Please log in again to complete your payment.");
            this.setState({
              guest: true,
              payment_methods: [],
              selected_payment_method: null,
            });
            return;
          }
          this.proceedWithPayment(token, pm, stripe);
        })
        .catch(() => {
          alert('Unable to verify your session. Please try again.');
        });
      return;
    }

    this.proceedWithPayment(token, pm, stripe);
  }

  proceedWithPayment(token, pm, stripe) {
    logEvent('matching: start monthly matching payment', {
      source: 'monthly_matching',
      pm_type: pm.type || null,
    });
    this.setState({ paying: true });
    // Step 2.1: handle ACH payment
    if (pm.type === 'ACH') {
      
      // ACH: Charges API (same style as gifting flow) – backend creates charge, no frontend confirmation
      GGApi.create_monthly_matching_ach_charge(token, pm.id)
        .then((res) => {
          if (res.message && (res.message.includes('error') || res.message.includes('Stripe'))) {
            alert(res.message || 'Payment failed');
            this.setState({ paying: false });
            return;
          }
          // success, set state to paid
          if (res.success) {
            this.setState({ paying: false, paid: true });
          
          } else {
            alert(res.message || 'Something went wrong. Please try again.');
            this.setState({ paying: false });
          }
        })
        .catch(() => {
          alert('Something went wrong. Please try again.');
          this.setState({ paying: false });
        });
      return;
    }

    // Step 2.2: handle CC payment
    if (!stripe) {
      alert('Please try again or contact the Greatest Gift support team.');
      this.setState({ paying: false });
      return;
    }
    // Step 2.2.1: create payment intent
    GGApi.create_monthly_matching_payment(token, pm.id, pm.type)
      .then((res) => {
        if (res.message && (res.message.includes('error') || res.message.includes('Stripe'))) {
          alert(res.message || 'Payment failed');
          this.setState({ paying: false });
          return;
        }
        if (!res.client_secret) {
          alert('Something went wrong. Please try again.');
          this.setState({ paying: false });
          return;
        }
        const setupFutureUsage = pm.save_this_method ? 'on_session' : null;
        const confirmOptions = { payment_method: pm.id };
        if (setupFutureUsage) confirmOptions.setup_future_usage = setupFutureUsage;
        
        // Step 2.2.2: confirm card payment
        stripe.confirmCardPayment(res.client_secret, confirmOptions).then((result) => {
          if (result.error) {
            alert(result.error.message || 'Payment failed');
            this.setState({ paying: false });
            return;
          }

          // Step 2.2.3: confirm monthly matching payment (CC)
          GGApi.confirm_monthly_matching_payment(token, res.pi_id).then((confirmRes) => {
            if (confirmRes.success) {
              if (pm.save_this_method) {
                GGApi.pm_create(pm.id, pm.type, pm.pm_name || pm.main_text, pm.pm_last4 || pm.sub_text?.replace(/\D/g, '').slice(-4), pm.image);
              }
              this.setState({ paying: false, paid: true });
            } else {
              alert(confirmRes.message || 'Payment confirmed on card but processing failed. Please contact GG support.');
              this.setState({ paying: false });
            }
          }).catch(() => {
            alert('Payment confirmed on card but we could not complete processing. Please contact GG support.');
            this.setState({ paying: false });
          });
        });
      })
      .catch(() => {
        alert('Something went wrong. Please try again.');
        this.setState({ paying: false });
      });
  }

  render() {
    const { loading, invalid, error, details, guest, payment_methods, selected_payment_method, open_payments, paying, paid } = this.state;
    const token = this.getToken();
    const returnTo = `/monthly-matching?t=${encodeURIComponent(token)}`;
    // Token-gated matcher payment flow — email deep link only; excluded from sitemap.
    const noindexHelmet = (
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
    );

    if (loading) {
      return (
        <>
          {noindexHelmet}
        <div className="monthly_matching_wrapper">
            <GG_loader />
        </div>
        </>
      );
    }

    if (invalid || error) {
      return (
        <>
          {noindexHelmet}
        <div className="monthly_matching_wrapper">
          <main className="monthly_matching_main monthly_matching_card">
            <h1 className="monthly_matching_title">Invalid or expired link</h1>
            <p className="monthly_matching_text">
              This link is invalid or has expired. If you have questions, please contact the person who sent you this link or email our support team.
            </p>
          </main>
        </div>
        </>
      );
    }

    if (paid && details) {
      return (
        <>
          {noindexHelmet}
        <div className="monthly_matching_wrapper">
          <GG_confetti />
          <main className="monthly_matching_main">
            <h2 className="monthly_matching_section_title">
              Gift matching summary for {details.month_label}
            </h2>
            <div className="monthly_matching_recipient_card">
              {details.media_url && (
                <div className="monthly_matching_recipient_img" style={{ backgroundImage: `url(${details.media_url})` }} />
              )}
              <div className="monthly_matching_recipient_name">{details.account_name}</div>
            </div>
            <div className="monthly_matching_payment_section">
              <h3 className="monthly_matching_payment_title green_text">Payment complete</h3>
              <p className="monthly_matching_text">
                Thank you for paying your matching for {details.account_name} in {details.month_label}.
              </p>
            </div>
          </main>
        </div>
        </>
      );
    }

    if (!details) return null;

    const totalCents = Number(details.total_matched_cents) || 0;
    const feeCents = this.calculateFees();
    const totalDueCents = totalCents + feeCents;
    const totalDueDollars = (totalDueCents / 100).toFixed(2);

    if (open_payments) {
      return (
        <div className="monthly_matching_wrapper monthly_matching_wrapper_white">
          <Header_for_multistep
            text="Add payment method"
            handleBackButton={() => this.setState({ open_payments: false })}
          />
          <main className="monthly_matching_main">
            <Payment_methods
              open_payments={true}
              guest={guest}
              stripe={this.props.stripe}
              elements={this.props.elements}
              updateCard={this.updateCard}
              bankNext={this.bankNext}
              remember_gift={() => {}}
              remember_gift_link={() => {}}
              save_gift_for_oauth={this.saveGiftForOauth}
              plaid_link_token={this.props.plaid_link_token}
              plaid_session={this.props.plaid_session}
              cleanupOauth={this.props.cleanupOauth}
              fc_client_secret={this.props.fc_client_secret}
              fc_return_session={this.props.fc_return_session}
              cleanupFcOauth={this.props.cleanupFcOauth}
              return_to={returnTo}
            />
          </main>
        </div>
      );
    }

    return (
      <>
        {noindexHelmet}
      <div className="monthly_matching_wrapper">
        <main className="monthly_matching_main">
          <Monthly_matching_summary
            details={details}
            guest={guest}
            payment_methods={payment_methods}
            selected_payment_method={selected_payment_method}
            returnTo={returnTo}
            paying={paying}
            totalDueDollars={totalDueDollars}
            feeCents={feeCents}
            onDDSelection={this.handleDDSelection}
            onGoToPayments={this.goToPayments}
            onPay={this.handlePay}
          />
        </main>
      </div>
      </>
    );
  }
}

export default Monthly_matching_page;
